export default {
  'menu.providerManagement': '服务商管理',
  'menu.providerManagement.admission': '入驻管理',
  'menu.providerManagement.admissionApply': '申请入驻',
  'menu.providerManagement.providerCompanies': '主体管理',
  'menu.providerManagement.providerCompanyDetail': '主体资质详情',
  'menu.admission': '入驻管理',
  'menu.admissionApply': '申请入驻',
  'menu.providerCompanies': '主体管理',
  'menu.providerCompanyDetail': '主体资质详情',
  'menu.customerManagement': '客户经营',
  'menu.customerManagement.leads': '线索',
  'menu.customerManagement.leadDetail': '线索详情',
  'menu.customerManagement.customers': '企业客户',
  'menu.customerManagement.customerDetail': '客户详情',
  'menu.customerManagement.opportunities': '服务机会',
  'menu.customerManagement.opportunityDetail': '机会详情',
  'menu.customers': '企业客户',
  'menu.customerDetail': '客户详情',
  'menu.opportunities': '服务机会',
  'menu.opportunityDetail': '机会详情',
  'menu.businessManagement': '业务管理',
  'menu.businessManagement.products': '服务商品',
  'menu.businessManagement.products.productCreate': '新建商品',
  'menu.businessManagement.products.productEdit': '编辑商品',
  'menu.businessManagement.products.productDetail': '商品详情',
  'menu.businessManagement.orders': '服务订单',
  'menu.businessManagement.orders.orderDetail': '订单详情',
  'menu.products': '服务商品',
  'menu.productCreate': '新建商品',
  'menu.productEdit': '编辑商品',
  'menu.productDetail': '商品详情',
  'menu.orders': '服务订单',
  'menu.orderDetail': '订单详情',
  'menu.projects': '服务项目',
  'menu.projectDetail': '项目详情',
  'menu.serviceQuality': '服务质量',
  'menu.serviceQuality.reviews': '服务评价',
  'menu.serviceQuality.qualityImprovements': '质量改进',
  'menu.reviews': '服务评价',
  'menu.qualityImprovements': '质量改进',
  'menu.analytics': '经营分析',
  'menu.settings.capabilities': '服务能力',
  'menu.settings.reviewTags': '评价标签',
  'menu.capabilities': '服务能力',
  'menu.reviewTags': '评价标签',
  'menu.settings.lifecycleStages': '客户生命周期阶段',
  'menu.settings.signalTypes': '客户信号类型',
  'menu.settings.opportunityCloseReasons': '机会关闭原因',
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.settings': '业务设置',
  'menu.settings.permissions': '权限管理',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
